import {
  EventStatusEnum,
  ResourceStatusEnum,
  ResourceTypeEnum,
  UserStatusEnum,
} from '@/types/schema';

export const ALLOWED_CONTENT_TYPES = [
  ResourceTypeEnum.Article,
  ResourceTypeEnum.Course,
  ResourceTypeEnum.Path,
  ResourceTypeEnum.ExternalContent,
  ResourceTypeEnum.Scorm,
  ResourceTypeEnum.Survey,
];

export const ALLOWED_EVENT_STATUS = [
  EventStatusEnum.Scheduled,
  EventStatusEnum.Completed,
  EventStatusEnum.Waiting,
  EventStatusEnum.Started,
];

export const ALLOWED_CONTENT_STATUS = [ResourceStatusEnum.Published];

export const ALLOWED_USER_STATUS = [UserStatusEnum.Active];
